import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

const Modal = ({
	isOpen,
	onClose,
	children,
	title,
	options = {},
	allowClose = true,
}) => {
	const hasSetOverflowRef = useRef(false);

	useEffect(() => {
		console.log("modal effect", isOpen);
		if (isOpen) {
			// Add body class or other setup when modal opens
			document.body.style.overflow = "hidden";
			hasSetOverflowRef.current = true;
		} else if (hasSetOverflowRef.current) {
			// Only reset overflow if this component instance set it
			document.body.style.overflow = "";
			hasSetOverflowRef.current = false;
		}

		return () => {
			// Cleanup on unmount - only reset if this component instance set overflow
			if (hasSetOverflowRef.current) {
				document.body.style.overflow = "";
				hasSetOverflowRef.current = false;
			}
		};
	}, [isOpen]);

	// If modal is not open, render nothing
	if (!isOpen) {
		return null;
	}

	const modalContent = (
		<div
			className={`lity ${isOpen ? "lity-opened" : ""} lity-inline`}
			role="dialog"
			aria-label="Dialog Window (Press escape to close)"
			tabIndex="-1"
			aria-hidden={!isOpen}
		>
			<div
				className="lity-wrap"
				role="document"
				onClick={allowClose ? onClose : null}
			>
				<div className="lity-container strategiq-react-form">
					<div className="lity-content">
						<div
							id="gated-content-modal"
							className=""
							style={{ maxHeight: "1004px" }}
							onClick={(e) => e.stopPropagation()}
						>
							<div className="content-styles gated-form-modal__form">
								{children}
							</div>
						</div>
					</div>
					{allowClose && (
						<button
							className="lity-close"
							type="button"
							aria-label="Close (Press escape to close)"
							onClick={onClose}
						>
							×
						</button>
					)}
				</div>
			</div>
		</div>
	);

	// Render to body
	return createPortal(modalContent, document.body);
};

export default Modal;
